import React from "react";
import { Form, Select, Button, Input, Row, Col, Skeleton } from "antd";
import UserInfoContent from "@frontend/components/shared/user-info-content/UserInfoContent";

const EditResponsableForm = ({
  onSubmitResponsible,
  handleInfiniteScroll,
  handleCancel,
  onSearch,
  handleSelect,
  selectionProcess,
  loading,
  userList,
  form,
  firstLoading
}) => {
  const { getFieldDecorator } = form;
  const initialValues = {
    responsible_user_id: selectionProcess?.responsible?.id,
    author: selectionProcess?.author?.full_name,
  };
  return (
    <Form layout="vertical" onSubmit={(e) => onSubmitResponsible(e, form)}>
      {firstLoading && <Skeleton active paragraph={{ rows: 2 }} />}

      {!firstLoading && (
        <>
          <Form.Item name="responsible_user_id" label="Responsable">
            {getFieldDecorator("responsible_user_id", {
              initialValue: initialValues.responsible_user_id,
            })(
              <Select
                showSearch
                placeholder="Responsable"
                optionFilterProp="label"
                onSearch={onSearch}
                loading={loading}
                onSelect={handleSelect}
                onPopupScroll={handleInfiniteScroll}
                optionLabelProp="label"
                filterOption={(input, option) => {
                  const label = option?.props.label?.toString().toLowerCase() || "";
                  const words = input.toLowerCase().split(" ");

                  return words.some(word => label.includes(word));
                }}
              >
                {userList.data.map((item,index) => (
                  <Select.Option
                    key={index}
                    value={item.id}
                    label={`${item.full_name} - ${item.email}` || ""}
                  >
                    <UserInfoContent user={item} />
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
          <Form.Item name="author" label="Creador">
            {getFieldDecorator("author", {
              initialValue: initialValues.author,
            })(<Input disabled />)}
          </Form.Item>
        </>
      )}

      <Row justify="end">
        <Col span={4} style={{ float: "right" }}>
          <Button type="primary" className="br-5" htmlType="submit" disabled={firstLoading}>
            Guardar
          </Button>
        </Col>
        <Col span={4} style={{ float: "right", marginRight: "10px" }}>
          <Button
            className="workflow-new-request-modal-cancel-button"
            onClick={handleCancel}
          >
            Cancelar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const FormEditResponsable = Form.create({ name: "edit-responsable-form" })(
  EditResponsableForm
);

export default FormEditResponsable;
